// balanceSheetConstants.js
const CURRENCIES = [
    { code: 'AED', symbol: 'د.إ', label: 'AED - د.إ' },
    { code: 'SAR', symbol: '﷼', label: 'SAR - ﷼' },
    { code: 'USD', symbol: '$', label: 'USD - $' },
    { code: 'EUR', symbol: '€', label: 'EUR - €' },
    { code: 'CAD', symbol: '$', label: 'CAD - $' },
    { code: 'AFN', symbol: '؋', label: 'AFN - ؋' },
    { code: 'ALL', symbol: 'Lek', label: 'ALL - Lek' },
    { code: 'AMD', symbol: 'դր.', label: 'AMD - դր.' },
    { code: 'ARS', symbol: '$', label: 'ARS - $' },
    { code: 'AUD', symbol: '$', label: 'AUD - $' },
    { code: 'AZN', symbol: 'ман.', label: 'AZN - ман.' },
    { code: 'BAM', symbol: 'KM', label: 'BAM - KM' },
    { code: 'BDT', symbol: '৳', label: 'BDT - ৳' },
    { code: 'BGN', symbol: 'лв.', label: 'BGN - лв.' },
    { code: 'BHD', symbol: 'د.ب.‏', label: 'BHD - د.ب.‏' },
    { code: 'BIF', symbol: 'FBu', label: 'BIF - FBu' },
    { code: 'BND', symbol: '$', label: 'BND - $' },
    { code: 'BOB', symbol: 'Bs', label: 'BOB - Bs' },
    { code: 'BRL', symbol: 'R$', label: 'BRL - R$' },
    { code: 'BWP', symbol: 'P', label: 'BWP - P' },
    { code: 'BYN', symbol: 'BYN', label: 'BYN - BYN' },
    { code: 'BZD', symbol: '$', label: 'BZD - $' },
    { code: 'CDF', symbol: 'FrCD', label: 'CDF - FrCD' },
    { code: 'CHF', symbol: 'CHF', label: 'CHF - CHF' },
    { code: 'CLP', symbol: '$', label: 'CLP - $' },
    { code: 'CNY', symbol: 'CN¥', label: 'CNY - CN¥' },
    { code: 'COP', symbol: '$', label: 'COP - $' },
    { code: 'CRC', symbol: '₡', label: 'CRC - ₡' },
    { code: 'CVE', symbol: 'CV$', label: 'CVE - CV$' },
    { code: 'CZK', symbol: 'Kč', label: 'CZK - Kč' },
    { code: 'DJF', symbol: 'Fdj', label: 'DJF - Fdj' },
    { code: 'DKK', symbol: 'kr', label: 'DKK - kr' },
    { code: 'DOP', symbol: 'RD$', label: 'DOP - RD$' },
    { code: 'DZD', symbol: 'د.ج.‏', label: 'DZD - د.ج.‏' },
    { code: 'EGP', symbol: 'ج.م.‏', label: 'EGP - ج.م.‏' },
    { code: 'ERN', symbol: 'Nfk', label: 'ERN - Nfk' },
    { code: 'ETB', symbol: 'Br', label: 'ETB - Br' },
    { code: 'GBP', symbol: '£', label: 'GBP - £' },
    { code: 'GEL', symbol: 'GEL', label: 'GEL - GEL' },
    { code: 'GHS', symbol: 'GH₵', label: 'GHS - GH₵' },
    { code: 'GNF', symbol: 'FG', label: 'GNF - FG' },
    { code: 'GTQ', symbol: 'Q', label: 'GTQ - Q' },
    { code: 'HKD', symbol: '$', label: 'HKD - $' },
    { code: 'HNL', symbol: 'L', label: 'HNL - L' },
    { code: 'HRK', symbol: 'kn', label: 'HRK - kn' },
    { code: 'HUF', symbol: 'Ft', label: 'HUF - Ft' },
    { code: 'IDR', symbol: 'Rp', label: 'IDR - Rp' },
    { code: 'ILS', symbol: '₪', label: 'ILS - ₪' },
    { code: 'INR', symbol: '₹', label: 'INR - ₹' },
    { code: 'IQD', symbol: 'د.ع.‏', label: 'IQD - د.ع.‏' },
    { code: 'IRR', symbol: '﷼', label: 'IRR - ﷼' },
    { code: 'ISK', symbol: 'kr', label: 'ISK - kr' },
    { code: 'JMD', symbol: '$', label: 'JMD - $' },
    { code: 'JOD', symbol: 'د.أ.‏', label: 'JOD - د.أ.‏' },
    { code: 'JPY', symbol: '￥', label: 'JPY - ￥' },
    { code: 'KES', symbol: 'Ksh', label: 'KES - Ksh' },
    { code: 'KHR', symbol: '៛', label: 'KHR - ៛' },
    { code: 'KMF', symbol: 'FC', label: 'KMF - FC' },
    { code: 'KRW', symbol: '₩', label: 'KRW - ₩' },
    { code: 'KWD', symbol: 'د.ك.‏', label: 'KWD - د.ك.‏' },
    { code: 'KZT', symbol: 'тңг.', label: 'KZT - тңг.' },
    { code: 'LBP', symbol: 'ل.ل.‏', label: 'LBP - ل.ل.‏' },
    { code: 'LKR', symbol: 'SL Re', label: 'LKR - SL Re' },
    { code: 'LYD', symbol: 'د.ل.‏', label: 'LYD - د.ل.‏' },
    { code: 'MAD', symbol: 'د.م.‏', label: 'MAD - د.م.‏' },
    { code: 'MDL', symbol: 'MDL', label: 'MDL - MDL' },
    { code: 'MGA', symbol: 'MGA', label: 'MGA - MGA' },
    { code: 'MKD', symbol: 'MKD', label: 'MKD - MKD' },
    { code: 'MMK', symbol: 'K', label: 'MMK - K' },
    { code: 'MOP', symbol: 'MOP$', label: 'MOP - MOP$' },
    { code: 'MUR', symbol: 'MURs', label: 'MUR - MURs' },
    { code: 'MXN', symbol: '$', label: 'MXN - $' },
    { code: 'MYR', symbol: 'RM', label: 'MYR - RM' },
    { code: 'MZN', symbol: 'MTn', label: 'MZN - MTn' },
    { code: 'NAD', symbol: 'N$', label: 'NAD - N$' },
    { code: 'NGN', symbol: '₦', label: 'NGN - ₦' },
    { code: 'NIO', symbol: 'C$', label: 'NIO - C$' },
    { code: 'NOK', symbol: 'kr', label: 'NOK - kr' },
    { code: 'NPR', symbol: 'नेरू', label: 'NPR - नेरू' },
    { code: 'NZD', symbol: '$', label: 'NZD - $' },
    { code: 'OMR', symbol: 'ر.ع.‏', label: 'OMR - ر.ع.‏' },
    { code: 'PAB', symbol: 'B/.', label: 'PAB - B/.' },
    { code: 'PEN', symbol: 'S/.', label: 'PEN - S/.' },
    { code: 'PHP', symbol: '₱', label: 'PHP - ₱' },
    { code: 'PKR', symbol: '₨', label: 'PKR - ₨' },
    { code: 'PLN', symbol: 'zł', label: 'PLN - zł' },
    { code: 'PYG', symbol: '₲', label: 'PYG - ₲' },
    { code: 'QAR', symbol: 'ر.ق.‏', label: 'QAR - ر.ق.‏' },
    { code: 'RON', symbol: 'RON', label: 'RON - RON' },
    { code: 'RSD', symbol: 'дин.', label: 'RSD - дин.' },
    { code: 'RUB', symbol: 'руб.', label: 'RUB - руб.' },
    { code: 'RWF', symbol: 'FR', label: 'RWF - FR' },
    { code: 'SDG', symbol: 'SDG', label: 'SDG - SDG' },
    { code: 'SEK', symbol: 'kr', label: 'SEK - kr' },
    { code: 'SGD', symbol: '$', label: 'SGD - $' },
    { code: 'SOS', symbol: 'Ssh', label: 'SOS - Ssh' },
    { code: 'SYP', symbol: 'ل.س.‏', label: 'SYP - ل.س.‏' },
    { code: 'THB', symbol: '฿', label: 'THB - ฿' },
    { code: 'TND', symbol: 'د.ت.‏', label: 'TND - د.ت.‏' },
    { code: 'TOP', symbol: 'T$', label: 'TOP - T$' },
    { code: 'TRY', symbol: 'TL', label: 'TRY - TL' },
    { code: 'TTD', symbol: '$', label: 'TTD - $' },
    { code: 'TWD', symbol: 'NT$', label: 'TWD - NT$' },
    { code: 'TZS', symbol: 'TSh', label: 'TZS - TSh' },
    { code: 'UAH', symbol: '₴', label: 'UAH - ₴' },
    { code: 'UGX', symbol: 'USh', label: 'UGX - USh' },
    { code: 'UYU', symbol: '$', label: 'UYU - $' },
    { code: 'UZS', symbol: 'UZS', label: 'UZS - UZS' },
    { code: 'VES', symbol: 'Bs.S.', label: 'VES - Bs.S.' },
    { code: 'VND', symbol: '₫', label: 'VND - ₫' },
    { code: 'XAF', symbol: 'FCFA', label: 'XAF - FCFA' },
    { code: 'XOF', symbol: 'CFA', label: 'XOF - CFA' },
    { code: 'YER', symbol: 'ر.ي.‏', label: 'YER - ر.ي.‏' },
    { code: 'ZAR', symbol: 'R', label: 'ZAR - R' },
    { code: 'ZMW', symbol: 'ZK', label: 'ZMW - ZK' },
];

export const PERIOD_OPTIONS = [
  { value: 0, label: 'No Comparison' }, 
  ...Array.from({ length: 11 }, (_, i) => ({ 
    value: i + 1, 
    label: `${i + 1} previous periods`
  }))
];

export { CURRENCIES };